import api from './index'
import { axios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export async function login (parameter) {
  return axios({
    url: api.Login,
    method: 'post',
    data: parameter
  })
}

// export function getSmsCaptcha (parameter) {
//   return axios({
//     url: api.SendSms,
//     method: 'post',
//     data: parameter
//   })
// }
//
// export function getInfo () {
//   return axios({
//     url: api.UserInfo,
//     method: 'get',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

export function getCurrentUserNav (token) {
  return axios({
    url: '/user/nav',
    method: 'get'
  })
}

export function logout (data, headers) {
  const defaultHeaders = {
    'Content-Type': 'application/json;charset=UTF-8'
  }
  headers = headers !== undefined ? { ...defaultHeaders, ...headers } : defaultHeaders
  return axios({
    url: api.Logout,
    method: 'post',
    headers: headers,
    data: data
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
// export function get2step (parameter) {
//   return axios({
//     url: api.twoStepCode,
//     method: 'post',
//     data: parameter
//   })
// }
